/* flatoo native main-image gallery.
   Slides use browser-native scroll snap; Slick remains the image/variant state
   controller so thumbnail selection, zoom and color changes still work. */
(function(){
  'use strict';
  var registered = new WeakMap();
  var rootsWithObservers = new WeakSet();
  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)');
  function jQueryWithSlick(){
    var $=window.jQuery || window.$;
    return $ && $.fn && typeof $.fn.slick === 'function' ? $ : null;
  }
  function imageSlides(main){
    return Array.prototype.slice.call(main.querySelectorAll('.slick-track > .slick-slide:not(.slick-cloned)'));
  }
  function getList(main){return main && main.querySelector(':scope > .slick-list');}
  function getCurrent($,main){
    try{return Number($(main).slick('slickCurrentSlide')) || 0;}catch(e){return 0;}
  }
  function setPosition(root,state,index,behavior){
    if(!state.list || !state.list.isConnected)return;
    var slides=imageSlides(state.main);
    var safe=Math.max(0,Math.min(slides.length-1,Number(index)||0));
    if(!slides[safe] || !slides.length)return;
    var desired=slides[safe].offsetLeft - slides[0].offsetLeft;
    var max=Math.max(0,state.list.scrollWidth-state.list.clientWidth);
    desired=Math.max(0,Math.min(max,desired));
    if(Math.abs(state.list.scrollLeft-desired)<2)return;
    state.ignoreScrollUntil=Date.now()+(behavior==='smooth'?450:100);
    state.list.scrollTo({left:desired,behavior:behavior||'auto'});
  }

  /* flatoo main gallery desktop mouse drag v3:
     native pointer-following drag without turning on Slick's conflicting swipe handler. */
  var mouseLists=new WeakSet();
  function bindMouseDrag(root,state,list){
    if(mouseLists.has(list))return;
    mouseLists.add(list);
    var drag=null,frame=0,blockClickUntil=0;
    function stopMomentum(){
      if(frame){cancelAnimationFrame(frame);frame=0;}
      list.classList.remove('flatoo-main-dragging');
      state.mouseMoving=false;
    }
    function settle(){
      stopMomentum();
      if(state.scrollListener)state.scrollListener();
    }
    function coast(velocity){
      var reduced=reduceMotion && reduceMotion.matches;
      if(reduced || Math.abs(velocity)<0.08){settle();return;}
      velocity=Math.max(-1.65,Math.min(1.65,velocity));
      var previous=performance.now(),elapsed=0;
      function tick(now){
        frame=0;
        if(!list.isConnected){stopMomentum();return;}
        var dt=Math.min(32,Math.max(1,now-previous));
        previous=now;
        var before=list.scrollLeft;
        list.scrollLeft=before+velocity*dt;
        velocity*=Math.pow(0.82,dt/16);
        elapsed+=dt;
        if(elapsed<420 && Math.abs(velocity)>0.045 && Math.abs(list.scrollLeft-before)>0.1){
          frame=requestAnimationFrame(tick);
        }else settle();
      }
      frame=requestAnimationFrame(tick);
    }
    function finish(event,withMomentum){
      if(!drag || (event && event.pointerId!==drag.id))return;
      var previous=drag;
      drag=null;
      if(!previous.moved)return;
      blockClickUntil=performance.now()+400;
      try{
        if(list.hasPointerCapture(previous.id))list.releasePointerCapture(previous.id);
      }catch(e){}
      if(withMomentum)coast(previous.speed);
      else settle();
    }
    list.addEventListener('pointerdown',function(event){
      if(event.pointerType!=='mouse'||event.button!==0||!event.isPrimary)return;
      if(event.target.closest('button,input,select,textarea,video,iframe,model-viewer'))return;
      if(list.scrollWidth<=list.clientWidth+3)return;
      stopMomentum();
      drag={
        id:event.pointerId,x:event.clientX,y:event.clientY,left:list.scrollLeft,
        lastX:event.clientX,lastTime:performance.now(),speed:0,moved:false
      };
    },{passive:true});
    list.addEventListener('pointermove',function(event){
      if(!drag||event.pointerId!==drag.id)return;
      var dx=event.clientX-drag.x,dy=event.clientY-drag.y;
      if(!drag.moved){
        if(Math.abs(dx)<7||Math.abs(dx)<Math.abs(dy)*1.2)return;
        drag.moved=true;
        state.mouseMoving=true;
        list.classList.add('flatoo-main-dragging');
        try{list.setPointerCapture(event.pointerId);}catch(e){}
      }
      if(event.cancelable)event.preventDefault();
      list.scrollLeft=drag.left-dx;
      var now=performance.now(),dt=now-drag.lastTime;
      if(dt>=8){
        var instant=-(event.clientX-drag.lastX)/dt;
        drag.speed=0.35*drag.speed+0.65*instant;
        drag.lastX=event.clientX;
        drag.lastTime=now;
      }
    },{passive:false});
    list.addEventListener('pointerup',function(event){finish(event,true);});
    list.addEventListener('pointercancel',function(event){finish(event,false);});
    list.addEventListener('lostpointercapture',function(event){finish(event,false);});
    window.addEventListener('pointerup',function(event){finish(event,true);},{passive:true});
    list.addEventListener('click',function(event){
      if(event.detail>0 && performance.now()<blockClickUntil){
        event.preventDefault();
        event.stopImmediatePropagation();
      }
    },true);
    list.addEventListener('dragstart',function(event){
      if(event.target.closest('img,a'))event.preventDefault();
    });
  }
  function keepSlickNative($,main){
    try{
      var slider=$(main);
      if(slider.slick('slickGetOption','fade')!==false ||
         slider.slick('slickGetOption','infinite')!==false ||
         slider.slick('slickGetOption','swipe')!==false ||
         slider.slick('slickGetOption','touchMove')!==false ||
         slider.slick('slickGetOption','draggable')!==false){
        slider.slick('slickSetOption',{
          fade:false,infinite:false,swipe:false,touchMove:false,draggable:false,
          speed:320,cssEase:'ease'
        },true);
      }
      return slider.slick('slickGetOption','fade')===false;
    }catch(e){return false;}
  }

  function refresh(root,state,shouldPosition){
    var list=getList(state.main);
    if(!list || !state.main.classList.contains('slick-initialized'))return false;
    if(state.list !== list){
      if(state.list && state.scrollListener) state.list.removeEventListener('scroll',state.scrollListener);
      state.list=list;
      state.list.addEventListener('scroll',state.scrollListener,{passive:true});
      bindMouseDrag(root,state,state.list);
    }
    var width=Math.max(1,Math.round(list.clientWidth));
    state.main.style.setProperty('--flatoo-main-image-width',width+'px');
    // Avoid snapping over a smooth thumbnail-triggered image transition.
    if(shouldPosition!==false){
      window.requestAnimationFrame(function(){
        if(state.main.isConnected)setPosition(root,state,getCurrent(state.$,state.main),'auto');
      });
    }
    return true;
  }
  function onSettled(root,state){
    if(!state.list || !state.list.isConnected)return;
    if(Date.now()<state.ignoreScrollUntil || state.mouseMoving)return;
    var slides=imageSlides(state.main);
    if(!slides.length)return;
    var left=state.list.scrollLeft;
    var first=slides[0].offsetLeft;
    var best=0,delta=Infinity;
    slides.forEach(function(slide,i){
      var diff=Math.abs(slide.offsetLeft-first-left);
      if(diff<delta){delta=diff;best=i;}
    });
    var current=getCurrent(state.$,state.main);
    if(best!==current){
      state.fromScroll=true;
      try{state.$(state.main).slick('slickGoTo',best,true);}catch(e){}
      state.fromScroll=false;
    }
  }
  function install(root){
    if(!root.classList.contains('flatoo-pdp-refresh'))return false;
    var main=root.querySelector('.productView-image-wrapper .productView-nav');
    var $=jQueryWithSlick();
    if(!main || !main.classList.contains('slick-initialized') || !$)return false;
    var old=registered.get(main);
    if(old){
      if(!keepSlickNative($,main))return false;
      refresh(root,old);
      return true;
    }
    // If a product includes video or an interactive 3D model, keep the
    // theme gallery instead of blocking media interactions with native scroll.
    if(main.querySelector('.productView-video,video,iframe,product-model,model-viewer'))return true;
    var state={
      main:main,$:$,list:null,scrollTimer:null,scrollListener:null,
      ignoreScrollUntil:0,fromScroll:false,mouseMoving:false
    };
    state.scrollListener=function(){
      if(state.scrollTimer)window.clearTimeout(state.scrollTimer);
      state.scrollTimer=window.setTimeout(function(){onSettled(root,state);},150);
    };
    // A theme/variant reinitialization may restore fade and Slick mouse handlers.
    if(!keepSlickNative($,main))return false;
    registered.set(main,state);
    root.classList.add('flatoo-native-main-gallery');
    $(main).on('afterChange.flatooNativeMain',function(event,slick,index){
      if(!refresh(root,state,false) || state.mouseMoving)return;
      setPosition(root,state,index,state.fromScroll?'auto':(reduceMotion && reduceMotion.matches?'auto':'smooth'));
    });
    $(main).on('reInit.flatooNativeMain',function(){
      window.requestAnimationFrame(function(){
        if(keepSlickNative(state.$,state.main))refresh(root,state);
      });
    });
    refresh(root,state);
    return true;
  }
  function boot(root){
    install(root);
    if(rootsWithObservers.has(root))return;
    var wrapper=root.querySelector('.productView-image-wrapper');
    if(!wrapper)return;
    rootsWithObservers.add(root);
    var scheduled=false;
    // Remain attached: variation changes can replace the slider after initial setup.
    var observer=new MutationObserver(function(){
      if(scheduled)return;
      scheduled=true;
      requestAnimationFrame(function(){scheduled=false;install(root);});
    });
    observer.observe(wrapper,{childList:true,subtree:true});
    window.addEventListener('pagehide',function(){observer.disconnect();},{once:true});
  }
  function start(){
    document.querySelectorAll('[data-section-type="product"].flatoo-pdp-refresh').forEach(boot);
  }
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',start,{once:true});
  else start();
  var resizeTimer;
  window.addEventListener('resize',function(){
    window.clearTimeout(resizeTimer);
    resizeTimer=window.setTimeout(function(){
      document.querySelectorAll('.flatoo-native-main-gallery').forEach(function(root){
        var main=root.querySelector('.productView-image-wrapper .productView-nav');
        var state=registered.get(main);
        if(state)refresh(root,state);
      });
    },120);
  },{passive:true});
  document.addEventListener('shopify:section:load',start);
})();
